(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["msb-line-props"] && !Shopify.designMode) return;
  try {
    window.msbCartEdit = function (btn) {
    var c = btn.closest('[data-msb-lp]'); if (!c) return;
    var d = c.dataset;
    var urls = (d.photos || '').split('|').filter(function (u) { return u.indexOf('http') === 0; });
    var state = { lineKey: d.lineKey, variantId: parseInt(d.variantId, 10), kahraman: d.kahraman || '', cinsiyet: d.cinsiyet || '',
      hazirlayan: d.hazirlayan || '', iliski: d.iliski || '', not: d.not || '', photoUrls: urls, ts: Date.now() };
    try { localStorage.setItem('ms_wiz_edit_state', JSON.stringify(state)); } catch (e) {}
    var url = d.productUrl;
    window.location.href = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'edit_cart=1';
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["msb-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__msbPcJs) return; window.__msbPcJs = 1;
    var KEY = 'msb-favs';
    function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    function sync() {
      var favs = load();
      document.querySelectorAll('[data-msb-pc]').forEach(function (c) {
        var b = c.querySelector('[data-msb-fav]');
        if (b) b.setAttribute('aria-pressed', favs.indexOf(c.dataset.handle) > -1 ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-msb-fav]');
      if (!b) return;
      e.preventDefault();
      var h = b.closest('[data-msb-pc]').dataset.handle;
      var favs = load();
      var i = favs.indexOf(h);
      if (i > -1) favs.splice(i, 1); else favs.push(h);
      save(favs);
      sync();
    });
    // colour dots: switch the card to that colour in place (image, title, price, badge, links, add-to-cart); no page change
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-msb-sw]');
      if (!sw) return;
      e.preventDefault();
      var c = sw.closest('[data-msb-pc]');
      if (!c || sw.classList.contains('is-current')) return;
      var d = sw.dataset;
      c.querySelectorAll('[data-msb-sw]').forEach(function (x) { x.classList.toggle('is-current', x === sw); x.setAttribute('aria-pressed', x === sw ? 'true' : 'false'); });
      var img = c.querySelector('.msb-pc__img:not(.msb-pc__img--2)');
      if (img && d.img) {
        img.removeAttribute('srcset'); img.src = d.img; if (d.srcset) img.srcset = d.srcset;
        img.classList.remove('is-swap'); void img.offsetWidth; img.classList.add('is-swap');
      }
      var i2 = c.querySelector('.msb-pc__img--2'); if (i2) i2.remove();
      var v = c.querySelector('[data-msb-pc-vid]'); if (v) { v.pause(); v.remove(); }
      var vt = c.querySelector('.msb-pc__vtag'); if (vt) vt.remove();
      c.querySelectorAll('.msb-pc__imglink, .msb-pc__info, a.msb-pc__btn').forEach(function (a) { a.href = d.url; });
      c.dataset.handle = d.handle; sync();
      var t = c.querySelector('.msb-pc__title');
      if (t) { t.textContent = ''; if (d.lead) { var st = document.createElement('strong'); st.textContent = d.lead; t.appendChild(st); } t.appendChild(document.createTextNode(d.rest)); }
      var pr = c.querySelector('.msb-pc__price');
      if (pr) { pr.innerHTML = ''; var b = document.createElement('b'); b.textContent = d.price; pr.appendChild(b); if (d.compare) { var s = document.createElement('s'); s.textContent = d.compare; pr.appendChild(s); } }
      var bd = c.querySelector('.msb-pc__badge:not(.msb-pc__badge--out)');
      if (bd) { if (+d.pct > 0) { (bd.querySelector('b') || bd).textContent = '%' + d.pct; bd.parentNode.style.display = ''; } else bd.parentNode.style.display = 'none'; }
      var f = c.querySelector('[data-msb-pc-add]'), cta = c.querySelector('.msb-pc__cta');
      if (d.avail !== '1') { if (cta) cta.innerHTML = '<span class="msb-pc__btn is-out"><span>Tükendi</span></span>'; }
      else if (f && d.single === '1') { f.querySelector('[name=id]').value = d.var; }
      else if (cta) { cta.innerHTML = ''; var a = document.createElement('a'); a.className = 'msb-pc__btn'; a.href = d.url; a.innerHTML = '<span>Sepete ekle</span>'; cta.appendChild(a);
        fetch(d.url + '.js').then(function (r) { return r.json(); }).then(function (p) { buildPick(cta, p, d.url); }).catch(function () {}); }
      c.dataset.swapped = '1';
    });
    // add to cart without leaving the page (single-variant cards)
    function toast(msg) {
      var t = document.querySelector('.msb-toast');
      if (!t) { t = document.createElement('div'); t.className = 'msb-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
      t.innerHTML = msg; t.classList.add('is-on');
      clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
    }
    function addVariant(id, btn, fallback) {
      if (window.msbCart) {
        if (btn) btn.classList.add('is-loading');
        return window.msbCart.add([{ id: +id, quantity: 1 }]).catch(fallback).finally(function () { if (btn) btn.classList.remove('is-loading'); });
      }
      return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js').then(function (c) { return c.json(); }); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'msb-product-card', data: { itemCount: cart.item_count } } }));
          toast('Sepete eklendi <a href="/cart">Sepete git →</a>');
        }).catch(fallback);
    }
    function buildPick(cta, p, url) {
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      if (vs.length < 2) return;
      var h = '<div class="msb-pc__pick" data-msb-pc-pick><button type="button" class="msb-pc__btn" data-msb-pc-pick-open aria-expanded="false"><span>Sepete ekle</span></button><div class="msb-pc__opts" hidden><span class="msb-pc__opts-t">Seçenek seçin</span>';
      vs.forEach(function (v) { var b = document.createElement('span'); b.textContent = v.title.replace(/ \/ /g, ' · '); h += '<button type="button" class="msb-pc__opt" data-msb-pc-var="' + v.id + '">' + b.innerHTML + '</button>'; });
      cta.innerHTML = h + '</div></div>';
    }
    // multi-variant cards: open the option chips, then add the chosen variant
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-msb-pc-pick-open]');
      if (o) { e.preventDefault(); var box = o.parentNode.querySelector('.msb-pc__opts'); var open = box.hidden; box.hidden = !open; o.setAttribute('aria-expanded', open ? 'true' : 'false'); return; }
      var v = e.target.closest('[data-msb-pc-var]');
      if (!v) return;
      e.preventDefault();
      var pick = v.closest('[data-msb-pc-pick]'), card = v.closest('[data-msb-pc]');
      var url = card && card.querySelector('.msb-pc__imglink') ? card.querySelector('.msb-pc__imglink').href : '/cart';
      v.classList.add('is-loading');
      addVariant(v.dataset.msbPcVar, null, function () { location.href = url; }).then(function () {
        v.classList.remove('is-loading'); pick.querySelector('.msb-pc__opts').hidden = true;
        var sp = pick.querySelector('[data-msb-pc-pick-open] span'); if (sp) { sp.textContent = 'Eklendi ✓'; setTimeout(function () { sp.textContent = 'Sepete ekle'; }, 1600); }
      });
    });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-msb-pc-add]');
      if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('.msb-pc__btn');
      // masalsensin cart drawer present: add through it and open the drawer instead of the toast
      if (window.msbCart) {
        if (btn) btn.classList.add('is-loading');
        window.msbCart.add([{ id: +f.querySelector('[name=id]').value, quantity: 1 }])
          .catch(function () { f.submit(); })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
        return;
      }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +f.querySelector('[name=id]').value, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js').then(function (c) { return c.json(); }); })
        .then(function (cart) {
          if (btn) { var sp = btn.querySelector('span'); btn.classList.add('is-done'); if (sp) sp.textContent = 'Eklendi ✓'; setTimeout(function () { btn.classList.remove('is-done'); if (sp) sp.textContent = 'Sepete ekle'; }, 1600); }
          document.querySelectorAll('.msb-bn2 a[href*="/cart"] .msb-bn2__ic').forEach(function (ic) {
            var b = ic.querySelector('.msb-bn2__badge'); if (!b) { b = document.createElement('b'); b.className = 'msb-bn2__badge'; ic.appendChild(b); }
            b.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'msb-product-card', data: { itemCount: cart.item_count } } }));
          toast('Sepete eklendi <a href="/cart">Sepete git →</a>');
        })
        .catch(function () { f.submit(); });
    });
    // card videos: play on hover (mouse) / while mostly in view (touch), muted and looped
    function play(v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); v.classList.add('is-play'); }
    function stop(v) { v.pause(); v.classList.remove('is-play'); }
    var touch = window.matchMedia('(hover: none)').matches;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) play(e.target); else stop(e.target); });
    }, { threshold: [0, 0.6, 1] }) : null;
    function initVids() {
      document.querySelectorAll('[data-msb-pc-vid]:not([data-i])').forEach(function (v) {
        v.setAttribute('data-i', '1');
        if (touch) { if (io) io.observe(v); }
        else {
          var card = v.closest('[data-msb-pc]');
          card.addEventListener('mouseenter', function () { play(v); });
          card.addEventListener('mouseleave', function () { stop(v); });
        }
      });
    }
    if (document.readyState !== 'loading') initVids(); else document.addEventListener('DOMContentLoaded', initVids);
    document.addEventListener('shopify:section:load', initVids);
    setTimeout(initVids, 1500);
    if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
